import { FormTypes } from '../globalDestServiceConstants';
import {
  POST_GLOBAL_DESTINATION_SERVICES_FAILURE,
  POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE,
  POST_GLOBAL_LANGUAGE_TRAINING_FAILURE
} from 'modules/authorizations/store/types/globalTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import {
  postGlobalDestinationServices,
  postGlobalInternationalSchooling,
  postGlobalLanguageTraining
} from 'modules/authorizations/store/actions/global.actions';
import { useDispatch } from 'react-redux';

export const useCreateDataHandler = showToast => {
  const dispatch = useDispatch();

  const handleCreateDestinationServiceData = async (authId, globalId, form) => {
    const response = await dispatch(postGlobalDestinationServices(authId, globalId, form));
    if (response.type === POST_GLOBAL_DESTINATION_SERVICES_FAILURE) {
      showToast('Failed creating destination service, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }
    return true;
  };

  const handleCreateLanguageTrainingData = async (authId, globalId, form) => {
    const response = await dispatch(postGlobalLanguageTraining(authId, globalId, form));
    if (response.type === POST_GLOBAL_LANGUAGE_TRAINING_FAILURE) {
      showToast('Failed creating language training, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }
    return true;
  };

  const handleCreateInternationalSchoolingData = async (authId, globalId, form) => {
    const response = await dispatch(postGlobalInternationalSchooling(authId, globalId, form));
    if (response.type === POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE) {
      showToast('Failed creating international schooling, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }
    return true;
  };

  const createData = async (formType, authId, globalId, form) => {
    try {
      switch (formType) {
        case FormTypes.DestinationService:
          return await handleCreateDestinationServiceData(authId, globalId, form);
        case FormTypes.LanguageTraining:
          return await handleCreateLanguageTrainingData(authId, globalId, form);
        case FormTypes.InternationalSchooling:
          return await handleCreateInternationalSchoolingData(authId, globalId, form);
        default:
          console.error('Not a valid form type.');
          return false;
      }
    } catch (error) {
      showToast('Failed creating data, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }
  };

  return { createData };
};
